module.exports = __webpack_public_path__ + "img/cornerqr.0984efd6.svg";